import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import AppWizard from "../../../shared/appWizard/appWizard";
import SuccessBox from "../../../shared/successBox/successBox";
import NewrelicCreation from "./newrelicCreation";
import { useDispatch, useSelector } from "react-redux";
import { createNewrelicIntegration } from "../../../redux/actions/newrelicIntegrationActions";
import { clouds } from "../../../utils/icons";

import "./newrelicIntegration.scss";

const NewrelicIntegration = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [wizardState, setWizardState] = useState({});
  const [submitDisabled, setSubmitDisabled] = useState(true);
  const [loadingSubmit, setLoadingSubmit] = useState(false);

  const themeDark = useSelector(
    (state) => state.userPreferencesReducer.themeDark
  );

  const configWizard = [
    {
      step_title: "Setup",
      step_description: "New Relic integration details",
      content_title: "New Relic integration",
      content: (
        <NewrelicCreation
          wizardState={wizardState}
          setWizardState={setWizardState}
          setSubmitDisabled={setSubmitDisabled}
        />
      ),
      valid: true,
      beforeNextStep: async () => {
        setLoadingSubmit(true);

        const result = await dispatch(
          createNewrelicIntegration(
            wizardState.name,
            wizardState.apiKey,
            wizardState.accountNumber,
            wizardState.region
          )
        );
        setLoadingSubmit(false);
        if (!result?.ok) {
          throw new Error(
            `Failed to create New Relic integration.`
          );
        }
      },
    },
    {
      step_title: "Completion",
      step_description: "",
      content_title: "Integration Created!",
      content: (
        <SuccessBox
          setSubmitDisabled={setSubmitDisabled}
          subTitle="The Resources from the Integration will take up to one hour to appear in the inventory"
          doesTakeTime={true}
        />
      ),
      valid: true,
    },
  ];

  return (
    <div className="NewrelicIntegration">
      <AppWizard
        loadingSubmit={loadingSubmit}
        configWizard={configWizard}
        handleClose={() => history.goBack()}
        submitDisabled={submitDisabled}
        setSubmitDisabled={setSubmitDisabled}
        handleSubmit={() => history.push("/integrations")}
        iconSrc={clouds("newrelic", themeDark)}
      />
    </div>
  );
};

export default NewrelicIntegration;
